import {
  Box,
  SubTitle,
  Table,
  Icon,
  TableProps,
  LinkedTransactionsMap,
  LinkedTransactions as LinkedTransactionsType,
  TransactionType,
} from 'vopay';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TransactionTypeLabel } from 'UI';
import * as transactionDetailRoute from '../transactionDetail.route';

type LinkedTransactionInfoProps = {
  LinkedTransactions: LinkedTransactionsMap;
  Currency: string;
};

export default function LinkedTransactionInfo(props: LinkedTransactionInfoProps) {
  const { LinkedTransactions, Currency } = props;

  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.TransactionHistory.Details.LinkedTransactionInfo',
  });

  const { t: tGlobal } = useTranslation('translations');
  const subTransactionsAvailable = LinkedTransactions && LinkedTransactions.length > 0;

  const tableProps: TableProps = {
    name: 'account-billing-settings-list',
    columns: {
      transactionID: { header: t('transactionDetails.transactionID') || '' },
      transactionStatus: { header: t('transactionDetails.transactionStatus') || '' },
      transactionType: { header: t('transactionDetails.transactionType') || '' },
      errorMessage: { header: t('transactionDetails.errorMessage') || '' },
      timestamp: { header: t('transactionDetails.timestamp') || '' },
      view: { header: t('transactionDetails.view') || '' },
    },
    rows:
      LinkedTransactions?.map((subTransaction) => ({
        transactionID: subTransaction.TransactionID,
        transactionStatus: tGlobal(`Transaction.TransactionHistory.statuses.${subTransaction.TransactionStatus}`, {
          defaultValue: subTransaction.TransactionStatus,
        }),
        transactionType: <TransactionTypeLabel transactionType={subTransaction.TransactionType} />,
        errorMessage: subTransaction.FailureReason,
        timestamp: subTransaction.Timestamp,
        view: shouldShowView(subTransaction) ? (
          <Link
            to={transactionDetailRoute.getPath({
              transactionType: subTransaction.TransactionType,
              transactionID: subTransaction.TransactionID,
              currency: Currency,
            })}
          >
            <Box jc="center">
              <Icon icon="angleRight" size="xsm" />
            </Box>
          </Link>
        ) : (
          ''
        ),
      })) || [],
  };

  return (
    <div>
      {subTransactionsAvailable && (
        <Box mt="lg" mb="lg" flx="col">
          <SubTitle subTitle={t('linkedTransactions') || ''} />
        </Box>
      )}

      <Table {...tableProps} />
    </div>
  );

  function shouldShowView({ TransactionType: transactionType }: LinkedTransactionsType) {
    const isEFT = [TransactionType.EFT_FUNDING, TransactionType.EFT_WITHDRAWAL].includes(transactionType);

    const isInteract = [TransactionType.INTERACT_MONEY_REQUEST, TransactionType.INTERACT_BULK_PAYOUT].includes(
      transactionType,
    );

    const isCreditCard = [TransactionType.CREDIT_CARD].includes(transactionType);

    return isEFT || isInteract || isCreditCard;
  }
}
